export const SHOP = 'shop';
export const ENTRANCE = 'entrance';
export const ESCALATOR = 'escalator';
export const STAIRS = 'stairs';
export const ELEVATOR = 'elevator';
export const TOILET = 'toilets';
export const HANDICAP = 'handicap';
export const BABY_BOTTLE = 'baby-bottle';
export const BABY = 'baby';
export const INFO = 'info';
export const NODE = 'node';


// WEBPACK FOOTER //
// ./constants/objectTypes.js